export function dateGreater(a: Date, b: Date) {
  return a > b ? true : false;
}
